import { MdOutlineHealthAndSafety } from "react-icons/md";

export const isPrescriptionMessage = (text) => {
  if (!text || typeof text !== "string") return false;
  return text.includes("Resep Obat");
};

export const parsePrescriptionText = (text) => {
  try {
    const match = text.match(/\|\|PRESCRIPTION_DATA\|\|([\s\S]*?)\|\|END\|\|/);
    if (!match) return [];
    return JSON.parse(match[1]);
  } catch {
    const lines = text
      .split("\n")
      .filter((l) => l.startsWith("•"))
      .map((l) => ({
        product_name: l.replace("• ", ""),
        quantity: 1,
        notes: "",
      }));
    return lines;
  }
};

const PrescriptionMessageBubble = ({ text, isFromMe, time }) => {
  const items = parsePrescriptionText(text);

  return (
    <div
      className={`max-w-[70%] py-2 px-2.5 shadow-sm break-words text-md -mb-2 ${
        isFromMe
          ? "bg-secondary text-white rounded-tl-xl rounded-bl-xl rounded-tr-xl"
          : "bg-white text-slate-700 rounded-tr-xl rounded-br-xl rounded-bl-xl"
      }`}
    >
      <div className="flex items-center gap-2 mb-2">
        <span className="text-base">
          <MdOutlineHealthAndSafety size={20} className="text-red-400" />
        </span>
        <span className="font-medium text-base">Resep</span>
      </div>

      {items.length > 0 && (
        <ul className="list-disc ml-5 space-y-1">
          {items.map((item, i) => (
            <li key={i} className="leading-tight">
              {item.product_name} x{item.quantity} {item.uom} ({item.notes})
            </li>
          ))}
        </ul>
      )}

      <div className="text-right mt-1">
        <span className="text-sm opacity-70">{time}</span>
      </div>
    </div>
  );
};

export default PrescriptionMessageBubble;
